<div class="qr-code-preview">
  <button mat-icon-button [mat-dialog-close]="null" class="close">
    <mat-icon>close</mat-icon>
  </button>
  <div class="qr-code-preview-wrapper">

    <div class="spinner-wrapper" *ngIf="isPreviewNotAvailable">
      <div class="loading-wrapper">
        <mat-spinner class="load-spinner" diameter="80" strokeWidth="6"></mat-spinner>
        <p> {{ 'components.qrCodes.qrCodePreview.loadingText' | translate }} </p>
      </div>
    </div>

    <div class="qr-code-loading-wrapper" *ngIf="!qrCode; else qrCodeImage">
      <qrcode [qrdata]="defaultQrCodeData" [width]="320" [margin]="2"></qrcode>
    </div>

    <ng-template #qrCodeImage>
      <div class="qr-code-image-wrapper">
        <img [src]="qrCode.QrCodeUrl" (load)="onImageLoad()" alt="qr-code">
      </div>
    </ng-template>

    <div class="controls">
      <button mat-button [disabled]="isPreviewNotAvailable || (loadingService.isLoading$() | async)" (click)="print()">
        <mat-icon>print</mat-icon>
        <span> {{ 'qrCodeGenerate.qrCodeButton.print' | translate }} </span>
      </button>
      <button mat-button [disabled]="isPreviewNotAvailable || (loadingService.isLoading$() | async)" (click)="download()">
        <mat-icon>download</mat-icon>
        <span>{{ 'system.download' | translate }}</span>
      </button>
    </div>
  </div>
</div>
